import authenticated from './http-clients/authenticated'

export default {
  index({tenantID, topicID}) {
    return authenticated({
      url: `/tenants/${tenantID}/topics/${topicID}/items`,
      method: 'get'
    })
  },
  update({tenantID, topicID, data}) {
    return authenticated({
      url: `/tenants/${tenantID}/topics/${topicID}/items`,
      method: 'put',
      data
    })
  },
  destroy({tenantID, topicID, itemID}) {
    return authenticated({
      url: `/tenants/${tenantID}/topics/${topicID}/items/${itemID}`,
      method: 'delete'
    })
  },
  markComplete({tenantID, topicID, itemID}) {
    return authenticated({
      url: `/tenants/${tenantID}/topics/${topicID}/items/completed/${itemID}`,
      method: 'post'
    })
  },
  markIncomplete({tenantID, topicID, itemID}) {
    return authenticated({
      url: `/tenants/${tenantID}/topics/${topicID}/items/completed/${itemID}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/items.js